const state = {
  primaryColor: "",
  secondaryColor: "",
  primaryDarkerColor: "",
  secondaryDarkerColor: "",
  profileTextColor: "",
  cancelButtonColor: "",
  cancelButtonHoverColor: "",
  labelColor: null
};

const mutations = {
  setPrimaryColor(state, payload) {
    state.primaryColor = payload;
  },
  setSecondaryColor(state, payload) {
    state.secondaryColor = payload;
  },
  setPrimaryDarkerColor(state, payload) {
    state.primaryDarkerColor = payload;
  },
  setSecondaryDarkerColor(state, payload) {
    state.secondaryDarkerColor = payload;
  },
  setProfileTextColor(state, payload) {
    state.profileTextColor = payload;
  },
  setCancelButtonColor(state, payload) {
    state.cancelButtonColor = payload;
  },
  setCancelButtonHoverColor(state, payload) {
    state.cancelButtonHoverColor = payload;
  },
  setLabelColor(state, payload) {
    state.labelColor = payload;
  }
};

const actions = {
  setPrimaryColor({ commit }, payload) {
    commit("setPrimaryColor", payload);
  },
  setSecondaryColor({ commit }, payload) {
    commit("setSecondaryColor", payload);
  },
  setPrimaryDarkerColor({ commit }, payload) {
    commit("setPrimaryDarkerColor", payload);
  },
  setSecondaryDarkerColor({ commit }, payload) {
    commit("setSecondaryDarkerColor", payload);
  },
  setProfileTextColor({ commit }, payload) {
    commit("setProfileTextColor", payload);
  },
  setLabelColor({ commit }, payload) {
    commit("setLabelColor", payload);
  },
  setColor({ commit }, payload) {
    commit("setPrimaryColor", payload.primaryColor);
    commit("setSecondaryColor", payload.secondaryColor);
    commit("setPrimaryDarkerColor", payload.primaryDarkerColor);
    commit("setSecondaryDarkerColor", payload.secondaryDarkerColor);
    commit("setProfileTextColor", payload.profileTextColor);
    commit("setCancelButtonColor", payload.cancelButtonColor);
    commit("setCancelButtonHoverColor", payload.cancelButtonHoverColor);
    commit("setLabelColor", payload.labelColor);
  }
};

const getters = {
  primaryColor(state) {
    return state.primaryColor;
  },
  secondaryColor(state) {
    return state.secondaryColor;
  },
  primaryDarkerColor(state) {
    return state.primaryDarkerColor;
  },
  secondaryDarkerColor(state) {
    return state.secondaryDarkerColor;
  },
  profileTextColor(state) {
    return state.profileTextColor;
  },
  cancelButtonColor(state) {
    return state.cancelButtonColor;
  },
  cancelButtonHoverColor(state) {
    return state.cancelButtonHoverColor;
  },
  labelColor(state) {
    return state.labelColor;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/colors.js